module.exports = __webpack_public_path__ + "static/media/como-16.2603ca62.jpg";